import Vue from "vue";
import App from "./App/index.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import { config } from "@/config/constants.js";
import "@/util/functions";
const nprogress = require("nprogress");
import VueYoutube from 'vue-youtube';
import VueMeta from "vue-meta";


import "./registerServiceWorker";

import {
  configure as VeeValidate,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import "@/config/validation";

Vue.config.productionTip = false;
setInteractionMode("lazy");
Vue.use(VueYoutube)
Vue.use(VueMeta)
Vue.use(VeeValidate, {
  classes: true,// Sí queremos que ponga clases automáticamente
  // Indicar qué clase poner al input en caso de que sea
  // válido o inválido. Usamos Bootstrap 4
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid",
  },
  // Podría ser blur, change, etcétera. Si está vacío
  // entonces se tiene que validar manualmente
  events: "change|blur|keyup",
});
// import * as rules from "vee-validate/dist/rules";
//
// // install rules
// Object.keys(rules).forEach(rule => {
//   extend(rule, rules[rule]);
// });

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.prototype.$http = Axios;

Axios.interceptors.request.use((config) => {
  nprogress.start();
  return config;
}, (error) => {
  nprogress.done();
  return Promise.reject(error);
});

Axios.interceptors.response.use((response) => {
  nprogress.done();
  return response;
}, (error) => {
  nprogress.done();
  return Promise.reject(error);
});

const token = localStorage.getItem(config.token_key);
if (token) {
  Vue.prototype.$http.defaults.headers.common["access-token"] = token;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
